
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useNavigate } from 'react-router-dom';
import './avatar.css';

function AvatarScanner() {
  const navigate = useNavigate();

  const avatarQRLinks = [
    { url: 'https://tinyurl.com/5e22swpd', title: 'Veda Upanishad (Hindi)' },
    { url: 'https://tinyurl.com/mu6hmv3v', title: 'Veda Upanishad (English)' },
    { url: 'https://tinyurl.com/yuun2mb7', title: 'Sita Ram (Marathi)' },
    { url: 'https://tinyurl.com/26fwtde5', title: 'Shiva climate (Hindi)' },
    { url: 'https://tinyurl.com/2n298286', title: 'Shankar Speaks (English)' },
    { url: 'https://tinyurl.com/3fjn7p3u', title: 'Shankar Speaks (Hindi)' },
    { url: 'https://tinyurl.com/4xnyvuz7', title: 'Shakti Speaks (Hindi)' },
    { url: 'https://tinyurl.com/27xumfpv', title: 'Sanatan (Hindi)' },
    { url: 'https://tinyurl.com/yvf2msjw', title: 'Sanatan (English)' },
    { url: 'https://tinyurl.com/57yzdhrm', title: 'Saibaba (Hindi)' },
    { url: 'https://tinyurl.com/37mv9hrd', title: 'Ram Speaks Soul Patrol (Hindi)' },
    { url: 'https://tinyurl.com/4xumk9sz', title: 'PRUTL Game (Hindi)' },
    { url: 'https://tinyurl.com/mpc5tjz4', title: 'PRUTL Game - Girl - (Hindi)' },
    { url: 'https://tinyurl.com/4fnh8frk', title: 'Nagin (Hindi)' },
    { url: 'https://tinyurl.com/mr2b9maa', title: 'Museum Mom (English)' },
    { url: 'https://tinyurl.com/yrwu5uw2', title: 'Museum Introduction' },
    { url: 'https://tinyurl.com/4h966d5f', title: 'Mother (Hindi)' },
    { url: 'https://tinyurl.com/3tsjkk42', title: 'Mahaveer Jain (Hindi)' },
    { url: 'https://tinyurl.com/2p3vjt9k', title: 'Lion (Hindi)' },
    { url: 'https://tinyurl.com/5567z2cz', title: 'Krishna Sanatan (Hindi)' },
    { url: 'https://tinyurl.com/4bytf5mw', title: 'Krishna Ganesh Hindi' },
    { url: 'https://tinyurl.com/4f5pxbe7', title: 'Kalki Krishna (English)' },
    { url: 'https://tinyurl.com/bd8nyf5r', title: 'Kalki Krishna Eng Short' },
    { url: 'https://tinyurl.com/4whmjhzh', title: 'Kalki Krishna Eng Short 2' },
    { url: 'https://tinyurl.com/48b9wfuv', title: 'Kalki (Hindi)' },
    { url: 'https://tinyurl.com/4tzzk2fk', title: 'Kalki AIDHARMA (Hindi)' },
    { url: 'https://tinyurl.com/2dnf9bkm', title: 'Hanuman (Hindi)' },
    { url: 'https://tinyurl.com/3dt2zccn', title: 'GuruNanak (Hindi)' },
    { url: 'https://tinyurl.com/4vss33fp', title: 'Guliver (Marathi)' },
    { url: 'https://tinyurl.com/n2299zzn', title: 'Goat (Hindi)' },
    { url: 'https://tinyurl.com/wna6hzev', title: 'Garud (Marathi)' },
    { url: 'https://tinyurl.com/557xf77w', title: 'Fish (Marathi)' },
    { url: 'https://tinyurl.com/5yb5h3cr', title: 'Education (Hindi)' },
    { url: 'https://tinyurl.com/49c3xz7t', title: 'Cow (Hindi)' },
    { url: 'https://tinyurl.com/ycxwy4dv', title: 'Christ (English)' },
    { url: 'https://tinyurl.com/bdzna53s', title: 'Buddha (Hindi)' },
    { url: 'https://tinyurl.com/y4kdjuza', title: 'Buddha (Marathi)' },
    { url: 'https://tinyurl.com/bdxdvwcm', title: 'Ayyappa (Hindi)' },
    { url: 'https://tinyurl.com/yap8p7u9', title: 'Ayyappa (Tamil)' },
    { url: 'https://tinyurl.com/4keu6u6p', title: 'AshtaLakshmi - Hindi' },
    { url: 'https://tinyurl.com/yvuef5mz', title: 'AllKalki (Hindi)' },
    { url: 'https://tinyurl.com/4t35yfp5', title: 'AI Dharma (English)' },
  ];

  return (
    <div className="qr-scroll-container">
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h2 style={{ marginBottom: '20px', fontSize: '32px' }}>🎥 Avatar QR Codes</h2>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', justifyContent: 'center' }}>
        {avatarQRLinks.map((item, index) => (
          <div key={index} className="qr-item">
            <QRCodeSVG value={item.url} size={128} />
            <p className="qr-title">QR {index + 1}</p>
            <p className="qr-subtitle">{item.title}</p>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <button
          onClick={() => navigate('/admincommon')}
          className="qr-button"
          style={{ padding: '10px 25px', fontSize: '16px' }}
        >
          ⬅️ Go Back to Admin Panel
        </button>
      </div>
    </div>
  );
}

export default AvatarScanner;
